/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamLanguageDropdown200,
  GetApiV1ExamLanguageDropdown401,
  GetApiV1ExamLanguageDropdown500,
  GetApiV1ExamLanguageDropdownQueryResponse,
} from "../../types/examSharedController/GetApiV1ExamLanguageDropdown.ts";
import { stringStringBaseDropDownListViewModelSchema } from "../stringStringBaseDropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamLanguageDropdown200Schema = z.array(
  z.lazy(() => stringStringBaseDropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ExamLanguageDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamLanguageDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamLanguageDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamLanguageDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamLanguageDropdown500>;

export const getApiV1ExamLanguageDropdownQueryResponseSchema = z.lazy(
  () => getApiV1ExamLanguageDropdown200Schema,
) as unknown as ToZod<GetApiV1ExamLanguageDropdownQueryResponse>;
